import { takeEvery } from 'redux-saga/effects';
import { apiRequest } from './index';
import api from 'utils/api';
import * as powerboxActions from 'actions/Powerbox';
import history from 'utils/history';
import { Slide, toast } from 'react-toastify';
import { t } from 'i18n';
const getPowerboxList = apiRequest.bind(null, powerboxActions.getPowerboxList, api.getPowerboxList);
const getPowerbox = apiRequest.bind(null, powerboxActions.getPowerbox, api.getPowerbox);
const updatePowerbox = apiRequest.bind(null, powerboxActions.updatePowerbox, api.updatePowerbox);
const createPowerbox = apiRequest.bind(null, powerboxActions.createPowerbox, api.createPowerbox);
const assignPowerbox = apiRequest.bind(null, powerboxActions.assignPowerbox, api.assignPowerbox);
const deletePowerbox = apiRequest.bind(null, powerboxActions.deletePowerbox, api.deletePowerbox);

function* refreshList() {
  //remove all toast messages created by api-calls/page/... before displaying success message
  yield toast.dismiss();
  yield toast(t('messages.saved'), {
    transition: Slide,
    closeButton: true,
    autoClose: 2000,
    position: 'bottom-center',
    type: 'success',
  });
}

function* handleUpdateSuccess(action) {
  if (action.payload.options === 'redirect') {
    return yield history.push('/powerboxes');
  } else {
    //remove all toast messages created by api-calls/page/... before displaying success message
    yield toast.dismiss();
    yield toast(t('messages.saved'), {
      transition: Slide,
      closeButton: true,
      autoClose: 2000,
      position: 'bottom-center',
      type: 'success',
    });
  }
}
// function* handleUserPowerboxsRefresh() {
//   const getUserUuid = (state) => state.User.user.userUuid;
//   const userUuid = yield select(getUserUuid);

//   const arg = { id: userUuid }

//   yield apiRequest.apply(null, [ powerboxActions.getUserPowerboxs, api.getUserPowerboxs, arg ])
// }

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/

export function* watchGetPowerboxListRequest() {
  yield takeEvery(powerboxActions.GET_POWERBOX_LIST.REQUEST, getPowerboxList);
}

export function* watchGetPowerboxRequest() {
  yield takeEvery(powerboxActions.GET_POWERBOX.REQUEST, getPowerbox);
}

export function* watchCreatePowerboxRequest() {
  yield takeEvery(powerboxActions.CREATE_POWERBOX.REQUEST, createPowerbox);
}

export function* watchAssignPowerboxRequest() {
  yield takeEvery(powerboxActions.ASSIGN_POWERBOX.REQUEST, assignPowerbox);
}

export function* watchUpdatePowerboxRequest() {
  yield takeEvery(powerboxActions.UPDATE_POWERBOX.REQUEST, updatePowerbox);
}

export function* watchUpdatePowerboxSuccess() {
  yield takeEvery(powerboxActions.UPDATE_POWERBOX.SUCCESS, handleUpdateSuccess);
}

export function* watchDeletePowerboxRequest() {
  yield takeEvery(powerboxActions.DELETE_POWERBOX.REQUEST, deletePowerbox);
}

export function* watchDeletePowerboxSuccess() {
  yield takeEvery(powerboxActions.DELETE_POWERBOX.SUCCESS, getPowerboxList);
}

export function* watchCreatePowerboxSuccess() {
  yield takeEvery(powerboxActions.CREATE_POWERBOX.SUCCESS, refreshList);
}

export function* watchAssignPowerboxSuccess() {
  yield takeEvery(powerboxActions.ASSIGN_POWERBOX.SUCCESS, refreshList);
}
